<template>
  <form class="Box" v-on:submit.prevent="SendContinue">
    <Modal
      v-if="Modal"
      :Titulo="Titulo"
      :Texto="Texto"
      :Color="Color"
      @Aceptar="Aceptar"
    />
    <h1>egep</h1>
    <h3>Consultores</h3>
    <span> Consulting Management System </span>
    <div class="input">
      <p>Enter your email to send you a recovery email</p>
      <!--       <v-text-field
        solo
        label="Email"
        background-color="var(--dark-firts-color)"
        color="#fff"
        type="email"
        class="correo red"
        autofocus
        outline
        prepend-inner-icon="mdi-account"
      >
      </v-text-field> -->
      <div class="input" data-v-step="2">
        <font-awesome-icon icon="user" class="icono" />
        <input type="email" name="Email" placeholder=" Email" required />
      </div>
    </div>
    <button type="submit">CONTINUE</button>
  </form>
</template>
<script>
import Modal from "../../components/Modal.vue";
export default {
  data: () => ({
    Continue: false,
    Titulo: "Email sent",
    Texto:
      "We have sent a verification email, please go to your inbox and look for the verification code",
    Color: "background: var(--firts-color);",
    Modal: false,
  }),
  methods: {
    SendContinue() {
      this.Modal = true;
    },
    Aceptar(value) {
      this.Modal = value;
      this.$emit("ListenChildren", this.Continue);
    },
  },
  components: { Modal },
};
</script>
<style lang="css" scoped>
/* .correo >>> .v-text-field__slot input {
  color: var(--second-color);
}
.correo >>> .v-text-field__slot label {
  color: var(--second-color);
} */
.Box {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.input {
  width: 100%;
  color: var(--second-color);
  text-align: center;
}
.input input {
  width: 60%;
  margin: 1rem;
  height: 45px;
  border: none;
  background: var(--dark-firts-color);
  color: var(--second-color);
  border-radius: 15px;
  padding-left: 40px !important;
  padding: 5px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  outline: none;
}
.input input::placeholder {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: var(--second-color);
}
.icono {
  position: absolute;
  pointer-events: none;
  color: var(--second-color);
  font-size: 1.5rem;
  margin: 25px;
  margin-left: 30px;
  --webkit-margin-left: 30px;
}
.Box p {
  margin: 5%;
  font-size: 19px;
  color: var(--dark-firts-color);
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}
.Box a {
  text-decoration: none;
  color: var(--dark-third-color);
  width: 100%;
  text-align: end;
  margin-right: 41%;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}
.Box button {
  background: var(--firts-color);
  width: 60%;
  margin: 1rem;
  height: 2.7rem;
  border: none;
  border-radius: 15px;
  color: var(--second-color);
  font-size: 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.Box h1 {
  display: none;
}
.Box h3 {
  display: none;
}
.Box span {
  display: none;
}
@media (max-width: 1100px) {
  .Box p {
    font-size: 15px;
  }
  .Box input {
    width: 80%;
  }
  .Box button {
    width: 80%;
  }
}
@media (max-width: 800px) {
  .Box input {
    width: 60%;
  }
  .Box button {
    width: 60%;
    margin-bottom: 20px;
  }
  .Box {
    color: var(--second-color);
    justify-content: flex-end;
  }
  .Box p {
    color: var(--second-color);
    font-size: 1rem;
  }
  .Box h1 {
    display: block;
    font-size: 100px;
    text-align: center;
    margin: 0;
    color: var(--sixth-color);
    margin-bottom: -20px;
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Box h3 {
    display: block;
    font-size: 42px;
    margin: 5px;
    text-align: center;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Box a {
    color: var(--second-color);
    margin-bottom: 30px;
  }
  .Box span {
    display: block;
    margin: 10%;
    font-size: 1.5rem;
    text-align: center;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Box button {
    margin-bottom: 110px;
  }
}
@media (max-width: 600px) {
  .Box input {
    width: 80%;
  }
  .Box button {
    width: 80%;
    margin-bottom: 60px;
  }
}
@media (max-width: 400px) {
  .Box input {
    width: 90%;
    font-size: 15px;
  }
  .Box button {
    width: 90%;
    margin-bottom: 60px;
  }
}
</style>